import { render, staticRenderFns } from "./LoginForgotPassword.vue?vue&type=template&id=3ec20ba2&scoped=true&"
import script from "./LoginForgotPassword.vue?vue&type=script&lang=js&"
export * from "./LoginForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./LoginForgotPassword.vue?vue&type=style&index=0&id=3ec20ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec20ba2",
  null
  
)

export default component.exports